
const TUTORIAL_TOKEN = "token_valley_tutorial"

const isFirstTime = (): boolean => {
    if(localStorage.getItem(TUTORIAL_TOKEN)) return false;
    // biome-ignore lint/style/noUselessElse: <explanation>
    else return true
}

export const tutorialStart = () => {
    if(!isFirstTime) return;
    window.devtodev.tutorial(-1)
}

export const tutorialDisplayField = () => {
    if(!isFirstTime) return;
    window.devtodev.tutorial(1)
}

export const tutorialFirstTap = () => {
    if(!isFirstTime) return;
    window.devtodev.tutorial(2)
}

export const tutorialFirstSlot = () => {
    if(!isFirstTime) return;
    window.devtodev.tutorial(3)
}

export const tutorialFirstBuild = () => {
    if(!isFirstTime) return;
    window.devtodev.tutorial(4)
}

export const tutorialFirstMerge = () => {
    if(!isFirstTime) return;
    window.devtodev.tutorial(-2)
    localStorage.setItem(TUTORIAL_TOKEN, "completed");
}

export const setTutorialStep = (tutorialStep: number) => {
    if(localStorage.getItem(TUTORIAL_TOKEN)) return;
    window.devtodev.tutorial(tutorialStep)
    if(tutorialStep == -2) localStorage.setItem(TUTORIAL_TOKEN, "completed");
}